// SlidingBanner.js
import { Box } from "@mui/material";
import React from "react";
import Slider from "react-slick";
import Carousel from "react-material-ui-carousel";
 

const SlidingBanner = ({banners}) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false, // Add this line to remove arrows
    fade: true,
    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  

  // const banners = [
  //   {
  //     id: 1,
  //     img: "../img/slideBanner/SLIDE1.jpg",
  //     alt: "Slide 1",
  //   },
  //   {
  //     id: 2,
  //     img: "../img/slideBanner/SLIDE2.jpg",
  //     alt: "Slide 2",
  //   },
  //   {
  //     id: 3,
  //     img: "../img/slideBanner/SLIDE3.jpg",
  //     alt: "Slide 3",
  //   },
  // ];

  return (
    <Box
    
    >
      <Carousel {...settings}
       autoPlay={true}
        animation='slide'
        interval={1500}>
        {banners.map((banner) => (
          <Box
            key={banner.id}
            sx={{
              // width: "100vh",
              height: {md:"75vh", sm:"60vh" , xs:"45vh"},
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={banner.img}
              style={{
                width: "100%",
                height: "100%",
               
              }}
              alt={banner.alt}
            />
          </Box>
        ))}
      </Carousel>
    </Box>
  );
};

export default SlidingBanner;
